import { useDrokAccess } from "./use-drok-access";

/**
 * Whether the user may create and configure agents. False for employees and while access is still
 * loading, so entry points that create or configure things never flash up for an employee.
 */
export function useCanManageAgents(): boolean {
  return useDrokAccess() === "manage-agents";
}
